import React, {useState} from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';

import useAuth from "../../login/AuthContext";
import { useSnackbar } from "../../../hooks/useSnackbar";

import { Modal } from "../../../components/Modal";
import { Button } from "../../../UI/MUIButton";
import { useModalContext } from "../../../contexts/ModalContext/context";

import { NetworkInfo } from "./types";
import { EntrataNetworkMappings, RemoveEntrataMapping } from "../../../services/IntegrationApi";


interface IProps {
  networkMappings: NetworkInfo[];
  row: NetworkInfo;
  disabled?: boolean;
  setNetworkMapping: React.Dispatch<React.SetStateAction<EntrataNetworkMappings[]>>;
  userId?: number;
  propertyId?: number;
}

export const EntrataRowRemove: React.FC<IProps> = ({row, networkMappings, setNetworkMapping, userId, propertyId}) => {
  const [removing, setRemoving] = useState<boolean>(false);
  const { setIsOpen } = useModalContext();
  const { getAuthToken } = useAuth();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();

  const removeMapping = async () => {
    if (!userId || !propertyId) {
      showErrorSnackbar('Missing user or property information');
      return;
    }

    setRemoving(true);
    if(row.id) {
    try {
      const result =  await RemoveEntrataMapping(userId, propertyId, row?.id.toString(), await getAuthToken());
      
      const newMappings = networkMappings.filter((x) => x.id!== row.id);
      setNetworkMapping(newMappings);
      
      showSuccessSnackbar(`Successfully removed mapping!`);
      setRemoving(false);
      setIsOpen(false);


      return result?.ok;
    } catch (error) { 
        showErrorSnackbar(error);
        setRemoving(false);
        setIsOpen(false);
    }}
  };

  const handleSettingsCopy = () => setIsOpen(true);

  return (
    <>
      <IconButton onClick={handleSettingsCopy} disabled={!row.id}>
        <DeleteIcon />
      </IconButton>
      <Modal
        maxWidth="xs"
        title="Are you sure you want to delete this mapping?"
        actions={
          [<Button color="primary" variant="outlined" onClick={removeMapping} disabled={removing}>
            Yes
          </Button>,
          <Button color="warning" variant="outlined" onClick={()  => setIsOpen(false)} disabled={removing}>
            No
          </Button>
          
        ]
        }
      >
      </Modal>
    </>
  );
};
